import React from 'react';
import PropTypes from 'prop-types';
import styles from './SignInLayout.css';
import { AppHeader } from '../../components/AppHeader';

function SignInLayout({ children }) {
    return (
        <main className={styles.root}>
            <AppHeader className={styles.header} />
            {children}
        </main>
    );
}

SignInLayout.propTypes = {
    children: PropTypes.any.isRequired
};

export {
    SignInLayout
};
